import {$authHost, $host} from "./index";
import { fetchCsrfToken } from "./userAPI";

export const createRating = async (productId, score) => {
    try {
        if (!productId || typeof score === 'undefined' || score === null) {
            console.error('createRating: productId или score не указаны', { productId, score });
            throw new Error('Не указан productId или score');
        }
        const {data} = await $authHost.post('api/rating', {
            productId: productId,
            score: score
        });
        return data;
    } catch (e) {
        console.error('Ошибка при отправке оценки:', e.response || e);
        if (e.response && e.response.data) {
            throw new Error(e.response.data.message);
        }
        throw new Error('Не удалось добавить оценку');
    }
}

export const fetchRatings = async (productId) => {
    try {
        const {data} = await $host.get('api/rating/' + productId);
        return data;
    } catch (e) {
        console.error('Ошибка при получении оценок:', e);
        return []; // Возвращаем пустой массив в случае ошибки
    }
}

export const deleteRating = async (ratingId) => {
    try {
        if (!ratingId) throw new Error('ratingId не указан');

        // CSRF токен добавится интерсептором, но иногда cookie может быть ещё не готова.
        // Паранойя ради надёжности: добавим в body, если удалось получить токен.
        let csrfToken = null;
        try {
            csrfToken = await fetchCsrfToken();
        } catch (_) {
            csrfToken = null;
        }

        const { data } = await $authHost.delete(`api/rating/${ratingId}`, {
            data: csrfToken ? { _csrf: csrfToken } : undefined
        });
        return data;
    } catch (e) {
        console.error('Ошибка deleteRating:', e?.response || e);
        throw e;
    }
};